/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import { Space } from "antd";
import React from "react";
import { getMenuParentElements } from "../../menuHelpers";
import MobileMenu from "../ChildrenMenu/MobileMenu";

const MobileMainMenu = (props) => {
  const { homeurl, search, sitemegamenu, sitemegamenumuotolevy } = props;
  const homeUrl = `${homeurl}/?s`;
  const parentMenu = getMenuParentElements(
    sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
  );
  const [toggleMenu, setToggleMenu] = React.useState(false);
  if (!parentMenu) return null;
  return (
    <Space>
      <a
        className="search-mobile js-muotolevy-search-header"
        href={homeUrl}
        onClick={() => setToggleMenu(false)}
      >
        <img src={search} alt="search" />
      </a>
      <a
        role="button"
        className={`btn muotolevy-button__md megamenu-button ${
          toggleMenu ? "red-btn" : ""
        }`}
        onClick={() => {
          setToggleMenu(!toggleMenu);
        }}
      >
        {" "}
        <button
          className={`hamburger hamburger--squeeze nav-toggle ${
            toggleMenu ? "is-active" : ""
          }`}
          type="button"
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
      </a>

      {toggleMenu && <MobileMenu {...props} />}
    </Space>
  );
};

export default MobileMainMenu;
